import { Component, OnInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { NumberFractionQualifierService } from 'src/app/model/api-services/qualifiers/number-fraction-qualifier.service';

@Component({
	selector: 'app-number-percentage-input',
	templateUrl: './number-percentage-input.component.html',
	styleUrls: ['./number-percentage-input.component.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class NumberPercentageInputComponent extends InputComponent implements OnInit {

	public numericValue = 0;
	public minValue = 0;
	public maxValue = 100;


	SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		super.SetAttribute(layer, attribute);
		switch (this.attribute.type) {
			case 'text':
				this.numericValue = NumberFractionQualifierService.FromString(this.currentValue, this.casting.fractional, true);
				break;
			case 'int':
				this.numericValue = Math.round(this.currentValue);
				break;
			case 'float':
				this.numericValue = this.currentValue
				break;
		}

	}
	NumberChanged() {
		if (this.numericValue < this.minValue) {
			this.numericValue = this.minValue;
		}
		if (this.numericValue > this.maxValue) {
			this.numericValue = this.maxValue;
		}

		switch (this.attribute.type) {
			case 'text':
			case 'string':
				this.currentValue = NumberFractionQualifierService.ToString(this.numericValue, this.casting.fractional, this.casting.fixedDigits);
				break;
			default:
				this.currentValue = this.numericValue;
				break;
		}

	}
	Reset() {
		this.numericValue = 0;
	}

	constructor(private domNode: ElementRef,protected cdr: ChangeDetectorRef) {
		super(cdr);
		super._domNode = this.domNode;
	}

}
